import $ from "jquery";
// import CookieConsent from "@alpaga/cookie-consent";
import "./../styles/main.scss";
require('./woocommerce/Global');
require("./helpers/plugins");
require("./helpers/cookieConsent");
require('jquery.scrollto');
import Rellax from "rellax";
// require("./helpers/ihavecookies");
import Cookies from "js-cookie";
require("./map");
$(document).ready(function () {
    if ($("#pop-up-system").length) {
        var parent = $("#pop-up-system");
        var overlay = parent.children('.overlay');
        if (Cookies.get("closed") === void 0) {
            parent.show();
            parent.addClass("active");
        }
        overlay.on("click", function (e) {
            // parent.removeClass("active");
        });
        parent.on("click", ".Button", function (e) {
            e.preventDefault();
            Cookies.set("closed", true);
            location.reload();
            // parent.removeClass("active");
        });
    }
    $.extend($.scrollTo.defaults, {
        axis: 'y'
    });
    var rellax = null;
    if ($('*[data-rellax-speed]').length && $(window).width() > 1000) {
        rellax = new Rellax('*[data-rellax-speed]', {
            // speed: -2,
            center: true
            // center: false
        });
    }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    $(window).scroll(function () {
        if ($(window).scrollTop() > 150) {
            $('#main-header').addClass('background');
        }
        if ($(window).scrollTop() < 150) {
            $('#main-header').removeClass('background');
        }
    });
});
